import { useSelector } from "react-redux";
import { AppRootState } from "../../redux/reducers";
import { Link } from 'react-router-dom';
import "./styles/main.css";

const Dashboard = () => {
  const userData: any = useSelector((state: AppRootState) => state.userData);

  return (
    <div className="w-full lg:w-3/4 min-h-screen bg-gray-100 text-gray-900">
      <div className="dashboard">
        <h1 className="text-4xl mb-4">Welcome {userData.given_name}, we're glad you came!</h1>
        <p className="text-2xl">How can we help you today?</p>
        <div className="cards-container md:grid md:grid-cols-2 gap-4">
          <div className="card" style={{ marginLeft: 'auto', marginRight: 'auto'}}>
            <h2 className="text-brand-blue-400 text-xl font-medium mb-3">I'm Looking to Register a New Kit</h2>
            <p className="mb-16">You must register your kit prior to sending it to our lab in order to receive your results.</p>
            <Link to="/active">
              <button className="px-12 py-2.5 font-medium text-center text-white bg-brand-blue-400 hover:bg-brand-blue-500">Register New Kit</button>
            </Link>
          </div>
          <div className="card md:mt-0 mt-4" style={{ marginLeft: 'auto', marginRight: 'auto'}}>
            <h2 className="text-brand-blue-400 text-xl font-medium mb-3">I'm Looking to View My Test Results</h2>
            <p className="mb-16 min-h-72" style={{ minHeight: 72 }}>You will receive an email notifying you when your results are available to view.</p>
            <Link to="/history">
              <button className="px-12 py-2.5 font-medium text-center text-white bg-brand-blue-400 hover:bg-brand-blue-500">View Test Results</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
